import { defineChain } from 'viem';
import { bscTestnet as bscTestnetOrigin, sepolia as sepoliaOrigin, mainnet as mainnetOrigin, bsc as bscOrigin } from 'viem/chains';
import {
  DexBscPancakeSwap,
  DexBscPancakeSwapV3,
  DexConfig,
  DexMainnetUniswapV2,
  DexMainnetUniswapV3,
  DexMainnetUniswapV4,
  DexPancakeSwap,
  DexPancakeSwapV3,
  DexUniswapV2,
  DexUniswapV3,
  DexUniswapV4,
} from './AppSwapConfig';

export const sepolia = defineChain({
  ...sepoliaOrigin,
  nativeCurrency: { name: 'Sepolia Ether', symbol: 'SepoliaETH', decimals: 18 },
  iconUrl: `${import.meta.env?.VITE_VISUAL_URL}/Crypto/Chains/${sepoliaOrigin.id}.svg`,
  dexList: [DexUniswapV2, DexUniswapV3, DexUniswapV4] as DexConfig[],
  testnet: true,
});

export const bscTestnet = defineChain({
  ...bscTestnetOrigin,
  iconUrl: `${import.meta.env?.VITE_VISUAL_URL}/Crypto/Chains/${bscTestnetOrigin.id}.svg`,
  dexList: [DexPancakeSwap, DexPancakeSwapV3] as DexConfig[],
  testnet: true,
});

export const mainnet = defineChain({
  ...mainnetOrigin,
  nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  iconUrl: `${import.meta.env?.VITE_VISUAL_URL}/Crypto/Chains/${mainnetOrigin.id}.svg`,
  dexList: [DexMainnetUniswapV2, DexMainnetUniswapV3, DexMainnetUniswapV4] as DexConfig[],
});

export const bsc = defineChain({
  ...bscOrigin,
  rpcUrls: {
    ...bscOrigin.rpcUrls,
    default: {
      http: ['https://bsc-dataseed.bnbchain.org', 'https://bsc-dataseed.defibit.io', 'https://bsc.nodereal.io'],
    },
  },
  iconUrl: `${import.meta.env?.VITE_VISUAL_URL}/Crypto/Chains/${bscOrigin.id}.svg`,
  dexList: [DexBscPancakeSwap, DexBscPancakeSwapV3] as DexConfig[],
});

export const AllSupportedChains = [mainnet, bsc, sepolia, bscTestnet] as const;

export const MainnetSupported = import.meta.env?.VITE_ENABLE_MAINNET === 'true';
export const TestnetSupported = !MainnetSupported || import.meta.env?.VITE_ENABLE_TESTNET === 'true';

export const SupportedChains: typeof AllSupportedChains = AllSupportedChains.filter((chain) => {
  if (TestnetSupported && chain.testnet) return true;
  if (MainnetSupported && !chain.testnet) return true;
  return false;
}) as any;

export const SupportedChainMap = Object.fromEntries(SupportedChains.map((chain) => [chain.id, chain])) as Record<SupportedChainId, (typeof SupportedChains)[number]>;

export type SupportedChain = (typeof SupportedChains)[number];

export type SupportedChainId = SupportedChain['id'];

export const SupportedChainIds = SupportedChains.map((chain) => chain.id) as number[];

export const isSupportedChainId = (chainId: number): chainId is SupportedChainId => {
  return SupportedChainIds.includes(chainId);
};

export const defaultChain = SupportedChains[0];

export const defaultChainId = defaultChain.id;
